var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myorder" },
    _vm._l(_vm.orderList, function(item, idx) {
      return item.status == 3 || item.status == 9
        ? _c("div", { key: idx, staticClass: "order_box" }, [
            _c("div", { staticClass: "order_head" }, [
              _c("div", { staticClass: "head_le" }, [
                _c("img", {
                  attrs: {
                    src: _vm.shopData.iconUrl
                      ? _vm.shopData.iconUrl
                      : "../../static/image/bgimg.png",
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.shopData.name))])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "head_ri",
                  class: item.status == 9 ? "gray" : ""
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.exchangeStatus(item.status)) +
                      "\n      "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "order_center",
                on: {
                  click: function($event) {
                    return _vm.handleToDetail(item)
                  }
                }
              },
              [
                _vm._l(item.goodsList, function(it, idx) {
                  return _c("img", {
                    key: idx,
                    attrs: { src: it.goodsImageUrl }
                  })
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("共" + _vm._s(item.goodsList.length) + "件")
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "footers" }, [
              _c("div", { staticClass: "footers_time" }, [
                _vm._v(
                  "\n        下单时间：" +
                    _vm._s(
                      _vm.moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "footer_tot" }, [
                _vm._v("\n        合计 "),
                _c("span", { staticClass: "footer_money" }, [
                  _vm._v("￥" + _vm._s(item.amount))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "callShop",
                attrs: { href: "tel:" + _vm.shopData.tel }
              },
              [_vm._v("联系商家")]
            )
          ])
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ef00808", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef00808","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myOrder/index.vue
// module id = null
// module chunks = 